/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';

import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {ReactiveFormsModule} from '@angular/forms';
import {FieldLabelComponent} from '../field-label/field-label.component';
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule} from '@ngx-translate/core';
import {TextInputComponent} from '../text-input/text-input.component';
import {NumberInputComponent} from '../number-input/number-input.component';
import {EnumInputComponent} from '../enum-input/enum-input.component';

@Component({
  selector: 'app-name-id-input',
  imports: [
    FieldLabelComponent,
    IxModule,
    ReactiveFormsModule,
    TranslateModule,
    TextInputComponent,
    NumberInputComponent,
    EnumInputComponent,
  ],
  templateUrl: './name-id-input.component.html',
  styleUrl: '../input-components.scss',
})
export class NameIdInputComponent extends BaseFormFieldDirective {
  constructor() {
    super();
  }
}
